// Telegram'ning yangi OpenID Connect (native) login oqimi — eski
// iframe-widget (TelegramLoginButton.tsx) o'rniga. "Bosdi — qabul
// qildi — ilovaga kirdi" tarzida, bitta tugma, popup ochiladi.
//
// DIQQAT: bu ishlashi uchun BotFather'da bot (@prava_test_uz_bot,
// client_id 8519693891) uchun Web Login/OIDC "Allowed URLs" ro'yxatiga
// avtomind.uz qo'shilgan bo'lishi shart. Agar hali sozlanmagan bo'lsa,
// tugma bosilganda Telegram "Unsupported login flow" xatosini beradi —
// bu frontend xatosi emas, Telegram tomonidagi sozlama muammosi.
import { useEffect, useRef, useState } from "react";
import { authAPI, usersAPI } from "../api";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

const TELEGRAM_CLIENT_ID = "8519693891";

interface Props {
  role?: "user" | "teacher";
}

const TelegramIcon = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="12" fill="#29A9EA" />
    <path
      d="M17.5 7L5.5 11.7c-.8.3-.8.9-.1 1.1l3 .9 1.2 3.6c.1.4.3.5.6.5.3 0 .4-.1.6-.3l1.6-1.5 3.2 2.4c.5.3.9.1 1-.5l1.9-9c.2-.7-.2-1-.9-1z"
      fill="#fff"
    />
  </svg>
);

export default function TelegramOidcLoginButton({ role = "user" }: Props) {
  const { setAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (scriptLoadedRef.current || (window as any).Telegram?.Login) {
      scriptLoadedRef.current = true;
      return;
    }
    const script = document.createElement("script");
    script.src = "https://oauth.telegram.org/js/telegram-login.js";
    script.async = true;
    script.onload = () => {
      scriptLoadedRef.current = true;
    };
    document.head.appendChild(script);
  }, []);

  const handleClick = () => {
    const TgLogin = (window as any).Telegram?.Login;
    if (!TgLogin) {
      toast.error("Telegram login kutubxonasi hali yuklanmadi, qayta urining");
      return;
    }

    setLoading(true);
    TgLogin.auth(
      { client_id: TELEGRAM_CLIENT_ID, request_access: true },
      async (data: any) => {
        if (!data || data.error || !data.id_token) {
          setLoading(false);
          toast.error(
            data?.error ||
              "Telegram orqali kirib bo'lmadi (BotFather sozlamasi to'liq emas bo'lishi mumkin)",
          );
          return;
        }

        try {
          const res = await authAPI.telegramOidcLogin(data.id_token, role);
          const { access_token, refresh_token, user } = res.data;

          localStorage.setItem("token", access_token);
          localStorage.setItem("refresh_token", refresh_token);

          const meRes = await usersAPI.getMe();
          const me = meRes.data?.data ?? meRes.data;

          setAuth(access_token, {
            id: user.id,
            fullName: user.name,
            email: user.email ?? "",
            plan: "free",
            role: me.role,
            unique_code: me.unique_code || null,
            is_onboarded: me.is_onboarded ?? false,
          });

          window.location.href = "/dashboard";
        } catch (e: any) {
          toast.error(
            e?.response?.data?.message || "Backend telegram-oidc xato berdi",
          );
        } finally {
          setLoading(false);
        }
      },
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      style={{
        flex: 1,
        padding: "12px",
        borderRadius: 10,
        border: "1px solid #1E2D45",
        background: "#0D1526",
        color: "#E2E8F0",
        fontWeight: 800,
        fontSize: 14,
        cursor: loading ? "wait" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        transition: "all .2s",
        opacity: loading ? 0.7 : 1,
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLElement).style.borderColor = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLElement).style.borderColor = "#1E2D45";
      }}>
      <TelegramIcon />
      Telegram
    </button>
  );
}
